<template>
	<div id="UIMap">
		
        <div id="mapstyler_templates">
			
		</div>

		<div id="mapstyler_params">
			
			

		</div>
	</div>
</template>

<script>
import MapStyler from '../MapStyler.js'
export default {
	name: 'UIMap',
	props: {
		okanMap : Object
	},
	data: function() {
		return {

			mapStyler: new MapStyler()

		}
	},
	mounted() {

	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
		}

	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>